import { render, staticRenderFns } from "./AddTemplateWithPreview.vue?vue&type=template&id=6cbf24e0&scoped=true&"
import script from "./AddTemplateWithPreview.vue?vue&type=script&lang=js&"
export * from "./AddTemplateWithPreview.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplateWithPreview.vue?vue&type=style&index=0&id=6cbf24e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf24e0",
  null
  
)

export default component.exports